module.exports = __webpack_public_path__ + "static/media/W19-0522_Bistro_Burger_Mobile_767x845_EN.55ae786f.jpg";